module.exports = __webpack_public_path__ + "media/images/icon-spread-big@3x-502451298ce943d6c6518167f991f6e3.png";